// Deeplinks to one person in Mitarbeitendenverwaltung. staffId is matched exactly by the backend,
// unlike ?search=, which is a substring search and returns everyone whose number contains the digits.
export const STAFF_ID_PARAM = 'staffId';
export const USER_ID_PARAM = 'userId';

export const employeeManagementPath = ({ staffId, userId, tab, employee } = {}) => {
  const params = new URLSearchParams();
  if (tab && tab !== 'employees') params.set('tab', tab);
  if (staffId) params.set(STAFF_ID_PARAM, staffId);
  else if (userId) params.set(USER_ID_PARAM, userId);
  if (employee) params.set('employee', employee);
  const query = params.toString();
  return query ? `/employee-management?${query}` : '/employee-management';
};

export const deeplinkStaffId = searchParams => searchParams.get(STAFF_ID_PARAM) || null;

export const deeplinkUserId = searchParams => searchParams.get(USER_ID_PARAM) || null;

// What the search box shows while a deeplink filters the list, so the filter is visible and clearable.
export const deeplinkSearchValue = searchParams =>
  searchParams.get('search') || deeplinkStaffId(searchParams) || '';
